import { useState, useCallback, useEffect } from "react";
import { Typography, Grid, Paper, Divider, Stack, Button } from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import Title from "@/components/molecules/Title";
import type { Manuals } from "@/models/manuals";
import { DashboardConstants, DashboardForms } from "./DashboardConstants";
import { getShortDatetime } from "@/util/datetime";
import { getManualsAPI } from "@/util/api/manuals";
import type { AxiosError } from "axios";
import toast from "@/components/hoc/SnackbarAlert";
import type { ErrorResponse } from "@/common/CommonConstants";
import { Messages } from "@/util/Messages";

export const Dashboard = () => {
  const [manuals, setManuals] = useState<Manuals[]>([]);

  const onClickBtn = useCallback((id: number) => {
    window.open(`/manual/${id}`, "_blank", "noopener");
  }, []);
  const onClickForm = useCallback((url: string) => {
    window.open(url, "_blank", "noopener");
  }, []);

  useEffect(() => {
    getManualsAPI()
      .then((res) => {
        setManuals(
          res.data.sort((a, b) => a.name.localeCompare(b.name, "ja-JP")),
        );
      })
      .catch((e: AxiosError<ErrorResponse>) => {
        toast.error(
          `マニュアル情報の取得${Messages.ErrorOccurred}: ${
            e?.response?.data?.message ?? ""
          }`,
        );
      });
  }, []);

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{ paddingLeft: 2, paddingRight: 2, mt: 3 }}
      >
        <Grid container spacing={2} sx={{ display: "flex", pl: 2 }}>
          <Title style={{ flexGrow: 1 }}>{DashboardConstants.Dashboard}</Title>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ paddingLeft: 2, paddingRight: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={12}>
            <Paper
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                minHeight: "300px",
              }}
            >
              <Stack direction="row">
                <ArticleIcon />
                <Typography sx={{ fontSize: 18, pb: 0 }}>
                  {DashboardConstants.TitleManual}
                </Typography>
              </Stack>

              <Divider sx={{ mb: 2 }} />

              {manuals.map((manual) => (
                <Stack key={manual.id} direction="row">
                  <Button
                    variant="text"
                    onClick={() => onClickBtn(manual.id)}
                    sx={{
                      fontSize: 16,
                      pb: 0,
                      pt: 0,
                      textTransform: "none",
                      "&.MuiButtonBase-root:hover": {
                        bgcolor: "transparent",
                        color: "#0000ff",
                      },
                    }}
                  >
                    {`${manual.name}（${getShortDatetime(
                      manual.updatedAt,
                    )}最終更新）`}
                  </Button>
                </Stack>
              ))}

              <Stack direction="row" sx={{ mt: 2 }}>
                <ArticleIcon />
                <Typography sx={{ fontSize: 18, pb: 0 }}>
                  {DashboardConstants.TitleForm}
                </Typography>
              </Stack>

              <Divider sx={{ mb: 2 }} />

              {DashboardForms.map((form, i) => (
                <Stack key={form.url} direction="row">
                  <Button
                    variant="text"
                    onClick={() => onClickForm(form.url)}
                    sx={{
                      fontSize: 16,
                      pb: 0,
                      pt: 0,
                      textTransform: "none",
                      "&.MuiButtonBase-root:hover": {
                        bgcolor: "transparent",
                        color: "#0000ff",
                      },
                    }}
                  >
                    {`${String(i).padStart(3, "0")}_${form.name}`}
                  </Button>
                </Stack>
              ))}
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
